import { Flex } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

//UI
import { Textarea } from '@/components/Form'

//Helper

//Constant
import CollapsibleCard from '@/components/Elements/CollapsibleCard'
import { OfferBookingStatus } from '@eapproval/offer-shared'
import CostBudgetVendorSelection from '../../../components/CostBudgetVendorSelection'
import { useCostBudgetAccess } from './CostBudgetAccessProvider'

const PM040Selection = ({ costBudgetIndex }) => {
  const { setValue } = useFormContext()
  const { canEditPM040Procurement, canEditPM040Technical } = useCostBudgetAccess()

  const status = useWatch({ name: 'status' })
  const vendorDetails = useWatch({ name: `sourcing.costBudgets.${costBudgetIndex}.detail.subcontractors` }) ?? []

  const sourcingSelectedVendor = useWatch({
    name: `sourcing.costBudgets.${costBudgetIndex}.firstProcurementOfficerSelection.vendor`,
  })
  const sourcingSelectedVendorHistoryIndex = useWatch({
    name: `sourcing.costBudgets.${costBudgetIndex}.firstProcurementOfficerSelection.uploadHistoryIndex`,
  })
  const technicalSelectedVendor = useWatch({
    name: `sourcing.costBudgets.${costBudgetIndex}.firstTechnicalSelection.vendor`,
  })
  const technicalSelectedVendorHistoryIndex = useWatch({
    name: `sourcing.costBudgets.${costBudgetIndex}.firstTechnicalSelection.uploadHistoryIndex`,
  })
  const CTG = useWatch({
    name: `sourcing.costBudgets.${costBudgetIndex}.detail.CTG`,
  })

  useEffect(() => {
    if (CTG !== undefined && CTG !== null) {
      return
    }

    //All
    let maxQuotationAmount = 0
    vendorDetails.forEach((vendorDetail) => {
      vendorDetail.history.forEach((his) => {
        if (his.budget > maxQuotationAmount) {
          maxQuotationAmount = his.budget
        }
      })
    })

    if (sourcingSelectedVendor && sourcingSelectedVendorHistoryIndex > -1) {
      const selectedVendor = vendorDetails.find((detail) => detail?.vendor === sourcingSelectedVendor)
      if (selectedVendor && selectedVendor.history.length > sourcingSelectedVendorHistoryIndex) {
        const selectedHistory = selectedVendor.history[sourcingSelectedVendorHistoryIndex]
        if (selectedHistory) {
          const CTG = maxQuotationAmount - selectedHistory.budget
          setValue(`sourcing.costBudgets.${costBudgetIndex}.detail.CTG`, CTG, { shouldDirty: true })
        }
      }

      return
    }

    if (technicalSelectedVendor && technicalSelectedVendorHistoryIndex > -1) {
      const selectedVendor = vendorDetails.find((detail) => detail?.vendor === technicalSelectedVendor)
      if (selectedVendor && selectedVendor.history.length > technicalSelectedVendorHistoryIndex) {
        const selectedHistory = selectedVendor.history[technicalSelectedVendorHistoryIndex]
        if (selectedHistory) {
          const CTG = maxQuotationAmount - selectedHistory.budget
          setValue(`sourcing.costBudgets.${costBudgetIndex}.detail.CTG`, CTG, { shouldDirty: true })
        }
      }

      return
    }
  }, [sourcingSelectedVendorHistoryIndex, technicalSelectedVendorHistoryIndex, CTG])
  return (
    <CollapsibleCard title={'PM040'} defaultIsOpen={true}>
      <Flex direction={'column'} gap="2">
        <Flex>
          <CostBudgetVendorSelection
            costBudgetIndex={costBudgetIndex}
            selectionPath={`sourcing.costBudgets.${costBudgetIndex}.firstProcurementOfficerSelection`}
            selectionLabel={'Sourcing Selection'}
            canSelectionVendor={canEditPM040Procurement}
            canSelectQuotation={canEditPM040Procurement}
            canBeReference={false}
            hasRemark={false}
          />

          <CostBudgetVendorSelection
            costBudgetIndex={costBudgetIndex}
            selectionPath={`sourcing.costBudgets.${costBudgetIndex}.firstTechnicalSelection`}
            selectionLabel={'Technical Selection'}
            canSelectionVendor={canEditPM040Technical}
            canSelectQuotation={canEditPM040Technical}
            canBeReference={true}
            hasRemark={false}
          />
        </Flex>

        <Flex gap="2" px="2">
          <Textarea
            name={`sourcing.costBudgets.${costBudgetIndex}.firstProcurementOfficerSelection.remark`}
            label={Object.values(OfferBookingStatus).includes(status) ? 'Sourcing Decision' : 'Sourcing Suggestion'}
            disabled={!canEditPM040Procurement}
            isRequired={false}
          />
          <Textarea
            name={`sourcing.costBudgets.${costBudgetIndex}.firstTechnicalSelection.remark`}
            label={'Technical Comment'}
            disabled={!canEditPM040Technical}
            isRequired={canEditPM040Technical}
          />
        </Flex>
      </Flex>
    </CollapsibleCard>
  )
}

export default PM040Selection
